import { useEffect } from "react";
import { assetUrl, useSite } from "@/lib/site";

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content || "");
}

export function useSeo({ title, description, image, noindex = false, jsonLd = null }) {
  // Compare structured data by content, not object identity, so it only re-runs when it really changes.
  const ldText = jsonLd ? JSON.stringify(jsonLd) : "";
  const site = useSite();
  const desc = description || site.seo_description;
  const img = image || assetUrl(site.og_image_url);
  useEffect(() => {
    const full = title ? `${title} | ${site.name}` : site.seo_title || site.name;
    document.title = full;
    const url = window.location.origin + window.location.pathname;
    setMeta("name", "description", desc);
    setMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow");
    setMeta("property", "og:title", full);
    setMeta("property", "og:description", desc);
    setMeta("property", "og:url", url);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:image", img);
    setMeta("property", "og:site_name", site.name);
    setMeta("name", "twitter:card", "summary_large_image");
    let canon = document.head.querySelector('link[rel="canonical"]');
    if (!canon) {
      canon = document.createElement("link");
      canon.rel = "canonical";
      document.head.appendChild(canon);
    }
    canon.href = url;
    let ld = document.getElementById("ld-json");
    if (ldText) {
      if (!ld) {
        ld = document.createElement("script");
        ld.type = "application/ld+json";
        ld.id = "ld-json";
        document.head.appendChild(ld);
      }
      ld.textContent = ldText;
    } else if (ld) ld.remove();
  }, [title, desc, img, noindex, ldText, site.name, site.seo_title]);
}
